import type { ReactNode } from 'react';

/** Centered icon badge for empty states, errors, and success screens. */
export function StateIcon({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`mx-auto mb-3 grid size-16 place-items-center rounded-2xl bg-[#FFEFE6] text-[var(--cobalt)] ${className}`}>
      {children}
    </div>
  );
}
